export default Object.freeze({
  To: 'to',
  Copy: 'copy',
  CopyHidden: 'copy-hidden',
});
